module.exports = __webpack_public_path__ + "static/media/notfound.6ddc7aca.jpg";